import { OrderPaymentType } from "Infrastructure/Api/Api";
import { z } from "zod";

export const getEditPaymentFormModelSchema = () =>
	z.object({
		type: z.nativeEnum(OrderPaymentType).nullable().optional(),
		dateCreated: z.string().nullable().optional(),
		amount: z
			.number()
			.refine((val) => Number.isFinite(val))
			.optional()
			.nullable(),
	});

export type EditPaymentFormModel = z.infer<
	ReturnType<typeof getEditPaymentFormModelSchema>
>;
